import css from 'styled-jsx/css';

export default css`:global(iframe) {
  width: 640px;
  height: 859px; }
  @media only screen and (max-width: 500px) {
    :global(iframe) {
      width: 100vw;
      height: 1000px;
      overflow: hidden; } }

.form {
  position: relative;
  margin-top: 190px;
  transition: 2s;
  margin-bottom: 30px; }
  .form .wrap {
    width: 50%;
    max-width: 450px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 8px;
    padding: 20px;
    margin-bottom: 30px; }
    @media only screen and (max-width: 500px) {
      .form .wrap {
        width: 80%; } }
    .form .wrap h2 {
      font-size: 32px;
      margin-bottom: 30px; }
    .form .wrap h3 {
      font-size: 16px;
      margin-top: 22px; }
    .form .wrap p {
      font-size: 12px;
      line-height: 16px;
      margin-top: 5px; }
    .form .wrap input,
    .form .wrap select {
      margin: 30px 0 60px;
      width: 100%;
      border-top-width: 0;
      border-left-width: 0;
      border-right-width: 0;
      border-bottom-width: 1px;
      border-bottom-color: rgba(0, 0, 0, 0.2); }
    .form .wrap select {
      width: 176px;
      height: 48px; }
    .form .wrap input[type='checkbox'] {
      width: initial;
      margin-right: 10px; }
    .form .wrap label {
      font-size: 12px; }
    .form .wrap em {
      color: #d93025;
      font-size: 13px; }
    .form .wrap .botton {
      width: 88px;
      line-height: 36px;
      text-align: center;
      color: white;
      background-color: #1a73e8;
      border-radius: 3px;
      cursor: pointer; }
  .form .share {
    display: flex;
    justify-content: center; }
    .form .share img {
      width: 70px;
      margin: 0 35px; }
`